import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { ReactComponent as FolderOpenIcon } from "assets/images/app_svg/folder_open.svg";
import { ReactComponent as FolderCloseIcon } from "assets/images/app_svg/folder_close.svg";
import Tooltip from "App/common/ui/Tooltip";
import { LayoutContext } from "App/common/hoc/Layout";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import {
  addClientsToGroupStart,
  deleteDashboardGroupStart
} from "store/actions";
import { decodeHandler, decryptData } from "utils";
function AddToGroup(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);
  const { sPopupMethods } = React.useContext(SPopupContext);
  const [selectedGroup, setSelectedGroup] = React.useState(0);
  const { clientUUIDs, resetCheckList } = lState.slidingPopup.params;
  const [editDropdown, setEditDropdown] = React.useState(false);

  function addClientsToGroup() {
    let data = {
      groupID: selectedGroup,
      devices: [
        {
          mirrorID: decryptData(localStorage.getItem("mirrorId")),
          clientUUIDs: clientUUIDs
        }
      ]
    };
    props.addClientsToGroupStart(data);
    lMethods.closeSlidingPopup();
    resetCheckList();
  }

  React.useEffect(() => {
    if (props.notification && props.notification.slidingPopup) {
      sPopupMethods.showNotify(props.notification.slidingPopup);
      if (
        props.notification.slidingPopup.msg.includes("created successfully") ||
        props.notification.slidingPopup.msg.includes("deleted successfully")
      ) {
        setSelectedGroup(
          Object.keys(props.groupsObj.list).reduce(function(a, b) {
            return Math.max(a, b);
          })
        );
      }
    } else {
      sPopupMethods.closeNotify();
    }
  }, [props.notification]);

  return (
    <div className="slider_content is_relative">
      <div className="addtoGrop_cont">
        <div className="addGrp_hdBlk">
          <p>Select existing group or create new to add computers</p>
          <button
            type="button"
            className="slider_btn btn_primary openCreategrp"
            onClick={() =>
              lMethods.openPopup("createNewGroupDashboard", {
                execute: null,
                secondExecute: lMethods.closePopup(),
                showCancelButton: false,
                position: "slidingPopup"
              })
            }
          >
            New Group
          </button>
        </div>
        <div className="addGrp_cntBlk">
          <div className="addGrp_lstHeading">
            <span className="">IDrive Mirror</span>
          </div>
          <div className="addGrp_bdy">
            {Object.values(props.groupsObj.list).length > 0 ? (
              Object.values(props.groupsObj.list).map(
                group =>
                  group.groupId !== 0 && (
                    <ul className="addGrp_listWrap">
                      <li
                        className={[
                          "addGrp_list",
                          group.groupId === selectedGroup ? "selected" : ""
                        ].join(" ")}
                        onClick={() => setSelectedGroup(group.groupId)}
                      >
                        <span className="fldr_ico">
                          {group.groupId === selectedGroup ? (
                            <FolderOpenIcon />
                          ) : (
                            <FolderCloseIcon />
                          )}
                        </span>
                        <span className="grp_name">
                          {decodeHandler(group.groupName)}
                        </span>
                        <div
                          className="list_drpdwn_blk"
                          onClick={() => setEditDropdown(!editDropdown)}
                        >
                          <div className=" flex_center addGrp_setting">
                            <Tooltip
                              {...{ title: "Settings", placement: "top" }}
                            >
                              <span className="icon">
                                <span className="svg_computer_setting_icon">
                                  {" "}
                                </span>
                              </span>
                            </Tooltip>
                          </div>
                          <ul
                            className={[
                              "drpdown_ul",
                              editDropdown && group.groupId === selectedGroup
                                ? "active"
                                : ""
                            ].join(" ")}
                          >
                            <li
                              className="drpdown_li rename"
                              onClick={() =>
                                lMethods.openPopup("dashboardGroupsRename", {
                                  execute: null,
                                  secondExecute: lMethods.closePopup(),
                                  group: {
                                    clients: group.clients,
                                    clients_count: group.clients_count,
                                    groupId: group.groupId,
                                    groupName: decodeHandler(group.groupName)
                                  },
                                  showCancelButton: false,
                                  position: "slidingPopup"
                                })
                              }
                            >
                              <span className="rename_icn"></span>
                              <span>Rename</span>
                            </li>
                            <li
                              className="drpdown_li delete"
                              onClick={() =>
                                lMethods.openPopup("dashboardGroupsDelete", {
                                  execute: null,
                                  secondExecute: lMethods.closePopup(),
                                  group: group,
                                  showCancelButton: false,
                                  position: "slidingPopup"
                                })
                              }
                            >
                              <span className="delete_icn"></span>
                              <span>Delete</span>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  )
              )
            ) : (
              <div className="grp_empty_screen">
                <div className="img_holder flex_center">
                  <span className="empty_bg grp_icon"></span>
                </div>
                <p>No Group's are not available.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="slider_content_footer">
        <div className="slider_summary_btns">
          <div className="slider_summary_btns__inner">
            <div className="backup_image_btns just_flex">
              <div
                className={[
                  "slider_btn btn_primary add_to_grp",
                  parseInt(selectedGroup) === 0 ? "btn_disable" : ""
                ].join(" ")}
                onClick={() => {
                  if (selectedGroup !== "0") {
                    addClientsToGroup();
                  }
                }}
              >
                Add
              </div>
              <div
                className="slider_btn btn_cancel"
                onClick={() => lMethods.closeSlidingPopup()}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    groupsObj: state.dashboard.groups,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addClientsToGroupStart,
      deleteDashboardGroupStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToGroup);
